import type { AnyAction } from 'redux';

import { REMOVE_SEARCHED_MESSAGE_ID, UPDATE_SEARCHED_MESSAGE_ID } from './actionTypes';
import type { MessagesActionTypes, MessagesState } from './types';

export const initialState: MessagesState = {
  searchedMessageId: undefined,
  timestamp: Date.now(),
};

export default (state = initialState, incomingAction: AnyAction): MessagesState => {
  const action = incomingAction as MessagesActionTypes;

  switch (action.type) {
    case UPDATE_SEARCHED_MESSAGE_ID:
      return {
        ...state,
        searchedMessageId: action.searchedMessageId,
        timestamp: Date.now(),
      };
    case REMOVE_SEARCHED_MESSAGE_ID:
      return {
        ...state,
        searchedMessageId: undefined,
        timestamp: Date.now(),
      };
    default:
      return state;
  }
};
